import React, { useEffect, useState } from 'react';
import OneHotel from './OneHotel';

function HotelList({
  hotelsForView,
  departure,
  request_model,
  recomend_hotels,
  geoclient,
  onAction,
  onContinue,
  getHotelInfo,
  filteredOperators,
  toursLength,
  hotelsIdWithReviews
}) {
  const [localDeparture, setLocalDeparture] = useState('');
  const [initialHotelList, setInitialHotelList] = useState(
    JSON.parse(JSON.stringify(hotelsForView))
  );
  const [adjustedHotelList, setAdjustedHotelList] = useState(hotelsForView);
  const [initialRequestModel, setInitialRequestModel] = useState(request_model);
  const hotels = JSON.parse(JSON.stringify(hotelsForView));

  useEffect(() => {
    setLocalDeparture(departure);
    setInitialRequestModel(request_model);
  }, []);

  useEffect(() => {
    setInitialHotelList(hotels);
  }, [toursLength, hotelsForView]);

  useEffect(() => {
    setHotelMinPrice();
  }, [filteredOperators, initialHotelList]);

  function setHotelMinPrice() {
    const adjustedHotelList = initialHotelList.map((hotel) => {
      if (hotel?.tours?.tour) {
        const {tour} = hotel.tours;
        const checkedToursByPromo = checkPromoStatus(tour);
        const filteredToursByOperator = filterToursByOperator(checkedToursByPromo);
        let filteredMinPrice = Math.min(
          ...filteredToursByOperator.map((item) => item.price)
        );
        hotel.tours.tour = filteredToursByOperator;
        hotel.filteredMinPrice = filteredMinPrice;
        return hotel;
      }
    });
    const sortedHotelList = sortHotelsByPrice(adjustedHotelList);
    setAdjustedHotelList(sortedHotelList);
  }

  function sortHotelsByPrice(hotels) {
    return hotels.sort((a, b) => a.filteredMinPrice - b.filteredMinPrice);
  }

  function checkPromoStatus(tours) {
    if (initialRequestModel.promo === 0) return tours;
    if (initialRequestModel.promo === 2) {
      return (tours = tours.filter((tour) => checkPromo(tour)));
    } else if (initialRequestModel.promo === 1) {
      return (tours = tours.filter((tour) => !checkPromo(tour)));
    }
  }

  function filterToursByOperator(tours) {
    if (filteredOperators.length > 0) {
      return tours.filter((tour) =>
        filteredOperators.includes(tour.operatorcode)
      );
    } else return tours;
  }

  const checkPromo = (tour) => {
    return tour.promo == 1 || /promo|промо/.test(tour.tourname.toLowerCase());
  };

  return (
    <>
      {adjustedHotelList.length > 0 &&
        adjustedHotelList.map((hotel) => (
          <OneHotel
            key={hotel.hotelcode}
            hotel={hotel}
            localDeparture={localDeparture}
            requestModel={initialRequestModel}
            recomend_hotels={recomend_hotels}
            geoclient={geoclient}
            onAction={onAction}
            onContinue={onContinue}
            getHotelInfo={getHotelInfo}
            filteredOperators={filteredOperators}
            hotelsIdWithReviews={hotelsIdWithReviews}
          />
        ))}
    </>
  );
}

export default HotelList;
